import { h, Fragment } from "preact";
import { useLayoutEffect, useState } from "preact/hooks";
import { CSSTransition } from "react-transition-group";

import Alert from "./Alert.jsx";
import Icon from "./Icon.jsx";
import IconButton from "./IconButton.jsx";
import Modal from "./Modal.jsx";

export default function ModalForm({
  buttonRow,
  children,
  error,
  noOutsideClick,
  noScroll,
  onSubmit,
  onClose,
  opened,
  title,
}) {
  const [visible, setVisible] = useState(false);

  function handleCloseClick(event) {
    event.preventDefault();
    handleModalClose();
  }

  function handleModalClose(event) {
    event && event.preventDefault();
    setVisible(false);
    setTimeout(() => {
      onClose && onClose();
    }, 230);
  }

  useLayoutEffect(() => {
    setVisible(opened);
  }, [opened]);

  return (
    <Fragment>
      <CSSTransition
        in={visible}
        timeout={250}
        classNames="overlay"
        unmountOnExit
      >
        <div
          class="overlay"
          onClick={noOutsideClick ? null : handleModalClose}
        ></div>
      </CSSTransition>
      <CSSTransition in={visible} timeout={250} classNames="nioomi-modal">
        <Modal onClose={handleModalClose} noScroll={noScroll} visible={visible}>
          <div class="nioomi-modal__header">{title}</div>
          <form onSubmit={onSubmit}>
            <div class="nioomi-modal__content">{children}</div>
            {error && <Alert>{error}</Alert>}
            <div class="nioomi-modal__buttonRow">{buttonRow}</div>
          </form>
          <div class="nioomi-modal__closer">
            <IconButton onClick={handleCloseClick}>
              <Icon>close</Icon>
            </IconButton>
          </div>
        </Modal>
      </CSSTransition>
    </Fragment>
  );
}
